import type { DropdownProps } from '../Dropdown';

export const assertMultiSelect = <TMultiselect extends boolean>({
  multiselect,
  value,
  maxSelectedOptions,
}: Pick<
  DropdownProps<TMultiselect>,
  'multiselect' | 'value' | 'maxSelectedOptions'
>) => {
  if (!multiselect) {
    return;
  }
  if (!!value && !Array.isArray(value)) {
    throw new Error('value must be an array for multiselect dropdown');
  }
  if (maxSelectedOptions && maxSelectedOptions < 1) {
    throw new Error('maxSelectedOptions must be greater than 0');
  }
};
